import colors from "../colors.js";

export default colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
